export default __webpack_public_path__ + "static/media/values.c74f0b98.jpg";